import { getTestOptionIndexes } from '../../options-list/utils/test-indexes';
export const getItemProps = ({ option, index, getOptionProps, filteringValue }) => {
    const optionProps = getOptionProps(option, index);
    optionProps.filteringValue = filteringValue;
    const { inGroupIndex, groupIndex, throughIndex } = getTestOptionIndexes(option) || {};
    return {
        ...optionProps,
        ['data-group-index']: groupIndex,
        ['data-child-index']: inGroupIndex,
        ['data-test-index']: throughIndex,
    };
};
//# sourceMappingURL=get-item-props.js.map